import { Builder } from 'builder-pattern';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { GetAllCollectionUsecase } from '@modules/collections/application/usecases/getAllCollection.usecase';
import { IAllCollectionData } from '@modules/collections/domain/models/allCollection.model';
import { loadingStore } from '@modules/core/adapter/outbound/stores/ui.store';
import { AllCollectionRepositoryImpl } from '../../inbound/repositories/allCollection.repository';
export interface IAllCollectionList {
  collections: IAllCollectionData[];
  total: number;
  currentPage: number;
  canLoadMore: boolean;
}
interface AllCollectionState {
  allCollectionLimit: IAllCollectionList;
  fetchAllCollectionLimit: (currentPage: number, pageSize: number) => void;
  allCollection: IAllCollectionList;
  fetchAllCollection: () => void;
}
const initialState = Builder<IAllCollectionList>().collections([]).total(0).build();
export const allCollectionStore = create<AllCollectionState>()(devtools((set, get) => ({
  allCollectionLimit: initialState,
  fetchAllCollectionLimit: async (currentPage, pageSize): Promise<void> => {
    try {
      loadingStore.setState({
        isLoading: true
      });
      const allCollection = get().allCollectionLimit;
      const prevAllCollection = allCollection.collections ?? [];
      const allCollectionRepositoryImpl = new AllCollectionRepositoryImpl();
      const getAllCollectionUsecase = new GetAllCollectionUsecase(allCollectionRepositoryImpl);
      const result = await getAllCollectionUsecase.handle(prevAllCollection, currentPage, pageSize);
      if (result.isRight()) {
        set(() => ({
          allCollectionLimit: {
            ...allCollection,
            ...result.value
          }
        }));
      }
    } catch (err) {
      console.error('error fetchAllCollectionLimit', err);
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  },
  allCollection: initialState,
  fetchAllCollection: async (): Promise<void> => {
    try {
      loadingStore.setState({
        isLoading: true
      });
      const allCollection = get().allCollection;
      const allCollectionRepositoryImpl = new AllCollectionRepositoryImpl();
      const getAllCollectionUsecase = new GetAllCollectionUsecase(allCollectionRepositoryImpl);
      const result = await getAllCollectionUsecase.handle([], 1);
      if (result.isRight()) {
        set(() => ({
          allCollection: {
            ...allCollection,
            ...result.value
          }
        }));
      }
    } catch (err) {
      console.error('error fetchAllCollection', err);
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  }
})));